module.exports = __webpack_public_path__ + "img/image-men-in-meeting.c335600a.jpg";